// TabsulLandingPage.jsx
import React from "react";
import classes from "./TabsulLandingPage.module.css";
import green from "../Assets/green.png";

export default function TabsulLandingPage() {
  // ✅ Put your real links here
  const androidLink =
    "https://play.google.com/store/apps/details?id=YOUR_APP_ID";
  const iosLink = "https://apps.apple.com/app/idYOUR_APP_ID";

  const quotes = [
    "Practice daily. Progress automatically.",
    "Mock tests today. Confidence on exam day.",
    "Small revisions become big results.",
    "Your next level is one test away.",
    "Learn smart. Review faster. Score higher.",
    "Consistency beats intensity—every time.",
    "Train under time. Perform under pressure.",
    "Every attempt teaches you something.",
  ];

  return (
    <div className={classes.page}>
      {/* subtle pattern background */}
      <div className={classes.pattern} />

      <div className={classes.container}>
        {/* Logo (as you requested) */}
        <img className={classes.logo} src={green} alt="Tabsul" />

        {/* HERO */}
        <section className={classes.hero}>
          <div className={classes.heroLeft}>
            <h1 className={classes.h1}>
                App for <span className={classes.green}>Learning</span>{" "}
              & <span className={classes.yellow}>Exams</span>
            </h1>

            <p className={classes.p}>
              Minimal, focused, and designed for practice. Use Tabsul on the web
              and download the mobile app for quick revision anytime.
            </p>

            <div className={classes.ctaRow}>
              <a
                className={classes.primaryBtn}
                href={androidLink}
                target="_blank"
                rel="noreferrer"
              >
                Android (Google Play)
              </a>
              <a
                className={classes.secondaryBtn}
                href={iosLink}
                target="_blank"
                rel="noreferrer"
              >
                iOS (App Store)
              </a>
            </div>
          </div>

          <div className={classes.heroCard}>
            <div className={classes.cardTitle}>Motivation for learners</div>
            <div className={classes.quoteGrid}>
              {quotes.slice(0, 6).map((q, idx) => (
                <div key={idx} className={classes.quoteItem}>
                  <span className={classes.dot} />
                  <span className={classes.quoteText}>{q}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* LONG SCROLL SECTIONS */}
        <section className={classes.section}>
          <h2 className={classes.h2}>Why Tabsul</h2>
          <div className={classes.grid3}>
            <div className={classes.featureCard}>
              <div className={classes.featureTitle}>Mock Tests</div>
              <div className={classes.featureText}>
                Exam-like experience to build speed and confidence.
              </div>
            </div>
            <div className={classes.featureCard}>
              <div className={classes.featureTitle}>Verified Answers</div>
              <div className={classes.featureText}>
                Clear explanations to help you learn, not just memorize.
              </div>
            </div>
            <div className={classes.featureCard}>
              <div className={classes.featureTitle}>Track Progress</div>
              <div className={classes.featureText}>
                Improve with repetition and measurable performance.
              </div>
            </div>
          </div>
        </section>

        <section className={classes.sectionAlt}>
          <h2 className={classes.h2}>Quotes for Exam Days</h2>
          <div className={classes.quoteList}>
            {quotes.map((q, idx) => (
              <div key={idx} className={classes.longQuote}>
                <span className={classes.longQuoteMark}>“</span>
                <span>{q}</span>
              </div>
            ))}
          </div>
        </section>

        <section className={classes.section}>
          <h2 className={classes.h2}>Get the App</h2>
          <p className={classes.p}>
            Start practicing now. Download Tabsul on your device:
          </p>
          <div className={classes.ctaRow}>
            <a
              className={classes.primaryBtn}
              href={androidLink}
              target="_blank"
              rel="noreferrer"
            >
              Android (Google Play)
            </a>
            <a
              className={classes.secondaryBtn}
              href={iosLink}
              target="_blank"
              rel="noreferrer"
            >
              iOS (App Store)
            </a>
          </div>
        </section>

        {/* FOOTER CONTACT */}
        <footer className={classes.footer}>
          <div className={classes.footerTitle}>Contact</div>
          <a className={classes.email} href="mailto:info@tabsul.me">
            info@tabsul.me
          </a>
          <div className={classes.footerSub}>
            © {new Date().getFullYear()} Tabsul. All rights reserved.
          </div>
        </footer>
      </div>
    </div>
  );
}
